import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import JobInputForm from '../components/JobInputForm';
import LatexOutput from '../components/LatexOutput';
import LoadingSpinner from '../components/LoadingSpinner';
import axios from 'axios';

const HomePage = ({ webhookUrl }) => {
  const [jobPostingText, setJobPostingText] = useState('');
  const [generatedLatex, setGeneratedLatex] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (jobText) => {
    if (!webhookUrl) {
      setError('Please configure your N8N webhook URL first.');
      navigate('/settings');
      return;
    }

    setIsLoading(true);
    setError('');
    setSuccessMessage('');
    setJobPostingText(jobText);

    try {
      const response = await axios.post(webhookUrl, {
        chatInput: jobText
      }, {
        headers: {
          'Content-Type': 'application/json',
        }
      });

      console.log('Full N8N Response:', response.data);

      let latexCode = null;
      
      if (response.data) {
        latexCode = response.data['Updated Latex code'] || 
                   response.data['Updated latex code'] ||
                   response.data['updated latex code'] ||
                   response.data.updatedLatexCode || 
                   response.data.UpdatedLatexCode ||
                   response.data.latexCode || 
                   response.data.latex ||
                   response.data['Present Latex code'] ||
                   response.data.output ||
                   response.data.result;
        
        if (!latexCode && response.data.output) {
          latexCode = response.data.output['Updated Latex code'] ||
                     response.data.output.updatedLatexCode || 
                     response.data.output.latexCode || 
                     response.data.output.latex;
        }
        
        if (!latexCode && Array.isArray(response.data) && response.data.length > 0) {
          const firstItem = response.data[0];
          latexCode = firstItem['Updated Latex code'] ||
                     firstItem.updatedLatexCode || 
                     firstItem.latexCode || 
                     firstItem.latex ||
                     firstItem.output ||
                     firstItem.result;
        }
        
        if (!latexCode && typeof response.data === 'string') {
          try {
            const parsed = JSON.parse(response.data);
            latexCode = parsed['Updated Latex code'] || 
                       parsed.updatedLatexCode || 
                       parsed.latexCode || 
                       parsed.latex;
          } catch (parseErr) {
            console.log('Response is not JSON:', response.data);
          }
        }
      }

      if (latexCode && latexCode.trim()) {
        setGeneratedLatex(latexCode);
        setError('');
        setSuccessMessage('✓ Resume customized successfully • LaTeX code is ready to use');
      } else {
        console.error('Available response fields:', Object.keys(response.data || {}));
        setError(`No LaTeX code found in server response. Available fields: ${Object.keys(response.data || {}).join(', ')}`);
      }
    } catch (err) {
      setError('Failed to process job posting. Please check your N8N webhook URL and try again.');
      console.error('Error processing job posting:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClear = () => {
    setJobPostingText('');
    setGeneratedLatex('');
    setError('');
    setSuccessMessage('');
  };

  return (
    <>
      {/* Messages - Full Width */}
      {(successMessage || error) && (
        <div className="full-width-section">
          {successMessage && (
            <div className="success-message">
              <p>{successMessage}</p>
            </div>
          )}

          {error && (
            <div className="error-message">
              <p>{error}</p>
            </div>
          )}
        </div>
      )}

      {/* Split Screen Layout */}
      <div className="split-container">
        {/* Left Side - Job Input */}
        <div className="split-left">
          <JobInputForm 
            onSubmit={handleSubmit}
            onClear={handleClear}
            isLoading={isLoading}
          />
        </div>

        {/* Right Side - LaTeX Output */}
        <div className="split-right">
          {isLoading ? (
            <div className="latex-output">
              <div className="latex-output-header">
                <h2>Generating Resume...</h2>
                <p>Processing your job posting and customizing your resume</p>
              </div>
              <LoadingSpinner />
            </div>
          ) : generatedLatex ? (
            <LatexOutput 
              latexCode={generatedLatex}
              jobPosting={jobPostingText}
            />
          ) : (
            <div className="latex-output">
              <div className="latex-output-header">
                <h2>Generated LaTeX Code</h2>
                <p>Your customized resume will appear here after processing the job posting.</p>
              </div>
              <div className="empty-state">
                <h3>Ready to Generate</h3>
                <p>Paste a job posting on the left and click "Generate Resume" to get started.</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default HomePage;
